// 자동 생성: scripts/sync_blog_to_data.js 가 LivingLawAutoData.json 을 갱신합니다.
// 이 파일은 wrapper. 직접 수정 금지.
import data from "./LivingLawAutoData.json";
export const LivingLawAutoData = data;
